{
  "journalAudit.action.comparison.reviewed": "Answer comparison decided",
  "journalAudit.action.source.reindex_requested": "Source indexing restart requested",
  "v4.sources.classement.couleur": "Colour",
  "v4.sources.classement.couleur_amber": "Amber",
  "v4.sources.classement.couleur_blue": "Blue",
  "v4.sources.classement.couleur_emerald": "Emerald",
  "v4.sources.classement.couleur_pink": "Pink",
  "v4.sources.classement.couleur_red": "Red",
  "v4.sources.classement.couleur_slate": "Slate",
  "v4.sources.classement.couleur_violet": "Violet",
  "v4.sources.classement.creation_echec": "Creation failed.",
  "v4.sources.classement.cree": "Created.",
  "v4.sources.classement.creer_composant": "Create component",
  "v4.sources.classement.creer_etiquette": "Create label",
  "v4.sources.classement.creer_version": "Create target version",
  "v4.sources.classement.date_prevue": "Planned date",
  "v4.sources.classement.etiquettes": "Labels",
  "v4.sources.classement.livree": "Released",
  "v4.sources.classement.nom_composant": "New component name",
  "v4.sources.classement.nom_deja_pris": "This name is already used in this list.",
  "v4.sources.classement.nom_etiquette": "New label name",
  "v4.sources.classement.nom_obligatoire": "The name is required.",
  "v4.sources.classement.nom_version": "New target version name",
  "v4.sources.classement.nombre": "{{n}} in total",
  "v4.sources.classement.non_livree": "Not released",
  "v4.sources.classement.retour": "Project items",
  "v4.sources.classement.rubriques": "Components",
  "v4.sources.classement.titre": "Product classification",
  "v4.sources.classement.versions": "Target versions",
  "v4.sources.classement.vide_etiquettes": "No label.",
  "v4.sources.classement.vide_rubriques": "No component.",
  "v4.sources.classement.vide_versions": "No target version.",
  "v4.sources.code.AI_KILL_SWITCH_ACTIVE": "AI is stopped: this action cannot be done now.",
  "v4.sources.code.ALREADY_REVIEWED": "This comparison has already been decided: the decision has been reloaded.",
  "v4.sources.code.AMONT_INDEXATION_NON_RELANCABLE": "Only a failed indexing can be restarted: this source is indexed or being indexed.",
  "v4.sources.code.COMPARISON_NOT_RETRYABLE": "Only a failed comparison can be retried.",
  "v4.sources.code.COMPARISON_NOT_REVIEWABLE": "At least two complete, usable answers are needed before deciding.",
  "v4.sources.code.CORE_UNAVAILABLE": "AI is stopped: this action cannot be done now.",
  "v4.sources.code.CREATEUR_N_APPROUVE_PAS": "Separation of duties: whoever requested the comparison does not approve it; someone else decides.",
  "v4.sources.code.DROIT_NON_TENU": "You do not hold the required right on this project.",
  "v4.sources.code.MODEL_NOT_GRANTED": "One of the chosen models is not allowed for your organisation.",
  "v4.sources.code.NOT_FOUND": "Not found in this project.",
  "v4.sources.code.SELF_REVIEW_REFUSED": "You requested this comparison: someone else decides on it.",
  "v4.sources.code.STORAGE_UNAVAILABLE": "Document storage is currently unavailable.",
  "v4.sources.code.VALIDATION_ERROR": "The input is incomplete or invalid.",
  "v4.sources.code_historique": "Legacy code: {{code}}.",
  "v4.sources.comparaison.adresse_invalide": "This address does not designate a comparison.",
  "v4.sources.comparaison.approuvee": "Comparison approved.",
  "v4.sources.comparaison.approuver": "Approve",
  "v4.sources.comparaison.avancement.echec": "Failure: no model answered.",
  "v4.sources.comparaison.avancement.echec_partiel": "Partial failure: at least one model did not answer.",
  "v4.sources.comparaison.avancement.en_cours": "Comparison in progress: the models are answering.",
  "v4.sources.comparaison.avancement.terminee": "Comparison complete.",
  "v4.sources.comparaison.consommation": "Tokens: {{entree}} in, {{sortie}} out; time: {{temps}}",
  "v4.sources.comparaison.contenu_relu": "I have read the question and all the answers",
  "v4.sources.comparaison.decidee_approved": "Approved by {{qui}} on {{date}}. {{note}}",
  "v4.sources.comparaison.decidee_rejected": "Rejected by {{qui}} on {{date}}: {{note}}",
  "v4.sources.comparaison.decision": "Decision",
  "v4.sources.comparaison.decision_echec": "The decision was not recorded.",
  "v4.sources.comparaison.demandee_le": "On",
  "v4.sources.comparaison.demandeur": "Requested by",
  "v4.sources.comparaison.lecture_perimee": "The content changed since you read it: read it again.",
  "v4.sources.comparaison.non_decidable": "A decision is possible once the comparison is complete.",
  "v4.sources.comparaison.note": "Note",
  "v4.sources.comparaison.note_aide": "Required to reject.",
  "v4.sources.comparaison.note_obligatoire": "Write a note to reject.",
  "v4.sources.comparaison.panneau": "Model answers",
  "v4.sources.comparaison.question": "Question",
  "v4.sources.comparaison.quoi": "the comparison",
  "v4.sources.comparaison.refus_distinct": "Rejecting is a reviewer’s decision; whoever requested the comparison does not decide on it.",
  "v4.sources.comparaison.refusee": "Comparison rejected.",
  "v4.sources.comparaison.refuser": "Reject",
  "v4.sources.comparaison.relance_echec": "The retry failed.",
  "v4.sources.comparaison.relancee": "Comparison retried: the models are answering again.",
  "v4.sources.comparaison.relancer": "Retry the comparison",
  "v4.sources.comparaison.reponse_attendue": "Answer pending.",
  "v4.sources.comparaison.reponse_de": "Answer from {{modele}}",
  "v4.sources.comparaison.reponse_en_echec": "This model did not answer: {{erreur}}",
  "v4.sources.comparaison.retour": "All comparisons",
  "v4.sources.comparaison.source": "Source",
  "v4.sources.comparaison.source_approval": "Decision #{{id}}, section “{{section}}”",
  "v4.sources.comparaison.source_document": "Knowledge source {{id}}, section “{{section}}”",
  "v4.sources.comparaison.titre": "Answer comparison",
  "v4.sources.comparer.aucun_modele": "No model is allowed for your organisation.",
  "v4.sources.comparer.comparer": "Compare",
  "v4.sources.comparer.echec": "The comparison could not be started.",
  "v4.sources.comparer.etat.echec": "Failed",
  "v4.sources.comparer.etat.en_cours": "In progress",
  "v4.sources.comparer.etat.terminee": "Complete",
  "v4.sources.comparer.lancee": "Comparison started.",
  "v4.sources.comparer.liste": "Project comparisons",
  "v4.sources.comparer.minimum_deux": "Choose at least two models.",
  "v4.sources.comparer.modeles": "Models to compare",
  "v4.sources.comparer.modeles_autorises": "Allowed models",
  "v4.sources.comparer.nouvelle": "New comparison",
  "v4.sources.comparer.question": "Question asked to each model",
  "v4.sources.comparer.question_obligatoire": "Write the question to ask the models.",
  "v4.sources.comparer.titre": "Compare models",
  "v4.sources.comparer.vide": "No comparison in this project.",
  "v4.sources.etat.chargement": "Loading {{quoi}}…",
  "v4.sources.etat.en_cours": "In progress…",
  "v4.sources.etat.erreur": "{{quoi}}: loading failed.",
  "v4.sources.etat.introuvable": "{{quoi}}: not found in this project.",
  "v4.sources.etat.reessayer": "Retry",
  "v4.sources.etat.refus": "{{quoi}}: access denied.",
  "v4.sources.etat.vide": "Nothing to show.",
  "v4.sources.raison.traitement_absent": "Re-indexing is not available on this platform yet: delete the source, then upload it again to index it anew.",
  "v4.sources.sans_projet": "Choose a project first: this screen is about a project.",
  "v4.sources.source.adresse_invalide": "This address does not designate a source.",
  "v4.sources.source.apercu": "Preview",
  "v4.sources.source.auteur": "Added by",
  "v4.sources.source.citation_orpheline": "The cited passage is no longer in the document: the citation has been orphaned by a change.",
  "v4.sources.source.citations_conservees": "Existing citations of this source are kept.",
  "v4.sources.source.confirmer_suppression": "I confirm the permanent deletion of “{{nom}}”",
  "v4.sources.source.date": "On",
  "v4.sources.source.document_indisponible": "The document is unavailable in storage.",
  "v4.sources.source.effet_citations": "Existing citations of this source will be flagged as orphaned.",
  "v4.sources.source.effet_confirmation": "Tick the confirmation to delete.",
  "v4.sources.source.effet_definitif": "The document and its index vectors are permanently deleted.",
  "v4.sources.source.empreinte": "Fingerprint (SHA-256)",
  "v4.sources.source.empreinte_absente": "Not computed",
  "v4.sources.source.fiche": "Source details",
  "v4.sources.source.format_non_previsualisable": "The {{format}} format cannot be previewed: download the document.",
  "v4.sources.source.indexation.indexation_en_cours": "Indexing in progress.",
  "v4.sources.source.indexation.indexation_en_echec": "Indexing failed: the assistant cannot cite it.",
  "v4.sources.source.indexation.nominal": "Indexed: the assistant can cite it.",
  "v4.sources.source.magasin_indisponible": "Document storage is not responding: the preview will come back once it is reachable again.",
  "v4.sources.source.motif": "Reason: {{motif}}",
  "v4.sources.source.nom": "Name",
  "v4.sources.source.passage_localise": "The cited passage is present in the document.",
  "v4.sources.source.quoi": "the source",
  "v4.sources.source.relance_echec": "Indexing could not be restarted.",
  "v4.sources.source.relance_en_file": "Indexing restarted (attempt {{n}}): the job is queued; follow its progress here.",
  "v4.sources.source.relance_indisponible.inconnue": "Re-indexing is unavailable for the moment.",
  "v4.sources.source.relance_indisponible.traitement_absent": "Re-indexing is not available on this platform yet: delete the source, then upload it again to index it anew.",
  "v4.sources.source.relancee": "Indexing restarted.",
  "v4.sources.source.relancer": "Restart indexing",
  "v4.sources.source.retour": "All project sources",
  "v4.sources.source.suppression": "Delete the source",
  "v4.sources.source.suppression_echec": "Deletion failed.",
  "v4.sources.source.supprimee": "Source deleted.",
  "v4.sources.source.supprimer": "Delete permanently",
  "v4.sources.source.telechargee": "Download started.",
  "v4.sources.source.telechargement_echec": "The download failed.",
  "v4.sources.source.telecharger": "Download",
  "v4.sources.source.tentatives": "Indexing attempts: {{n}}",
  "v4.sources.source.titre": "Knowledge source"
}
